export type EventDataWinMeterCountUp = {
    from: number;
    to: number;
    duration: number;
};

export type EventDataWinMeterShowingFinalValue = {
    value: number;
    clearWithDelay?: boolean;
};

export type EventDataWinMeterSetValue = {
    value: number;
    setIfPlaying?: boolean;
};